module.exports = __webpack_public_path__ + "img/ax_crane.da761fee.png";